import { BaseModel } from '../../../../../core/_base/crud';
    export class NhaCungCapModel extends BaseModel {
            Id_NCC : number
            Id_LoaiNCC : number
            Id_Tinh : number
            MaNCC : string
            TenNCC : string
            MaLoaiNCC : string
            TenLoaiNCC : string
            Id_NhomNCC : number
            MaNhomNCC : string
            TenNhomNCC : string
            DienThoai : string
            DiaChi : string
            Fax : string
            MST : string
            SoTK1 : string
            NganHang1 : string
            SoTK2 : string
            NganHang2 : string
            Email : string
            NguoiLienHe : string
            SoDT_NguoiLienHe : string
            NguoiDaiDien : string
            SoDT_NguoiDaiDien : string
            GhiChu : string
            XepLoai : string
            Disable : boolean
            SoNgayThanhToan : string
            NguoiTao : number
            NgayTao : string
            NguoiSua : number
            NgaySua : string
            isError: boolean
            messageError: string
            nhomncc:string
            TenTinh:string
            LoaiHinhKD:string
            DieuKienThanhToan:string
            
        clear() {
            this.Id_NCC = 0;
            this.Id_LoaiNCC = 0;
            this.Id_Tinh = 0;
            this.MaNCC = '';
            this.TenNCC = '';
            this.TenLoaiNCC = '';
            this.MaLoaiNCC = '';
            this.Id_NhomNCC = 0;
            this.MaNhomNCC = '';
            this.TenNhomNCC = '';
            this.DienThoai = '';
            this.DiaChi = '';
            this.Fax = '';
            this.MST = '';
            this.SoTK1 = '';
            this.NganHang1 = '';
            this.SoTK2 = '';
            this.NganHang2 = '';
            this.Email = '';
            this.NguoiLienHe = '';
            this.SoDT_NguoiLienHe = '';
            this.NguoiDaiDien = '';
            this.SoDT_NguoiDaiDien = '';
            this.GhiChu = '';
            this.XepLoai = '';
            this.Disable = false;
            this.SoNgayThanhToan = '';
            this.NguoiTao = 0;
            this.NgayTao = '';
            this.NguoiSua = 0;
            this.NgaySua = '';
            this.isError = false;
            this.messageError = '';
            this.nhomncc='';
            this.TenTinh='';
            this.LoaiHinhKD='';
            this.DieuKienThanhToan='';
        }
        copy(item:NhaCungCapModel){
                this.Id_NCC = item.Id_NCC;
                this.Id_LoaiNCC = item.Id_LoaiNCC;
                this.Id_Tinh = item.Id_Tinh;
                this.MaNCC = item.MaNCC;
                this.TenNCC = item.TenNCC;
                this.TenLoaiNCC = item.TenLoaiNCC;
                this.DienThoai = item.DienThoai;
                this.DiaChi = item.DiaChi;
                this.Fax = item.Fax;
                this.MST = item.MST;
                this.SoTK1 = item.SoTK1;
                this.NganHang1 = item.NganHang1;
                this.SoTK2 = item.SoTK2;
                this.NganHang2 = item.NganHang2;
                this.Email = item.Email;
                this.NguoiLienHe = item.NguoiLienHe;
                this.SoDT_NguoiLienHe = item.SoDT_NguoiLienHe;
                this.NguoiDaiDien = item.NguoiDaiDien;
                this.SoDT_NguoiDaiDien = item.SoDT_NguoiDaiDien;
                this.GhiChu = item.GhiChu;
                this.XepLoai = item.XepLoai;
                this.Disable = item.Disable;
                this.SoNgayThanhToan = item.SoNgayThanhToan;
                this.NguoiTao = item.NguoiTao;
                this.NgayTao = item.NgayTao;
                this.NguoiSua = item.NguoiSua;
                this.NgaySua = item.NgaySua;
                this.isError = item.isError;
                this.messageError = item.messageError;
                this.nhomncc=item.nhomncc;
                this.TenTinh=item.TenTinh;
                this.TenNhomNCC=item.TenNhomNCC;
                this.Id_NhomNCC=item.Id_NhomNCC;
                this.LoaiHinhKD=item.LoaiHinhKD;
                this.DieuKienThanhToan=item.DieuKienThanhToan;
        }
    }


export class NhaCungCapImportModel extends BaseModel {   
            messageMaNCC : string
            messageTenNCC : string
            messageTenLoaiNCC : string      
            messageTenNhomNCC : string
            messageDienThoai : string
            messageDiaChi : string
            messageFax : string
            messageMST : string
            messageSoTK1 : string
            messageNganHang1 : string
            messageSoTK2 : string
            messageNganHang2 : string
            messageEmail : string
            messageNguoiLienHe : string
            messageSoDT_NguoiLienHe : string
            messageNguoiDaiDien : string
            messageSoDT_NguoiDaiDien : string
            messageGhiChu : string
            messageXepLoai : string
            messageSoNgayThanhToan : string
            messageTenTinh:string
            isError: boolean
        clear() {
           
            this.messageMaNCC = '';
            this.messageTenNCC = '';
            this.messageTenLoaiNCC = '';      
            this.messageTenNhomNCC = '';
            this.messageDienThoai = '';
            this.messageDiaChi = '';
            this.messageFax = '';
            this.messageMST = '';
            this.messageSoTK1 = '';
            this.messageNganHang1 = '';
            this.messageSoTK2 = '';
            this.messageNganHang2 = '';
            this.messageEmail = '';
            this.messageNguoiLienHe = '';
            this.messageSoDT_NguoiLienHe = '';
            this.messageNguoiDaiDien = '';
            this.messageSoDT_NguoiDaiDien = '';
            this.messageGhiChu = '';
            this.messageXepLoai = '';  
            this.messageSoNgayThanhToan = '';
            this.messageTenTinh='';
            this.isError=false;
        }
        copy(item:NhaCungCapImportModel){
            this.messageMaNCC = item.messageMaNCC;
            this.messageTenNCC = item.messageTenNCC;
            this.messageTenLoaiNCC = item.messageTenLoaiNCC;      
            this.messageTenNhomNCC = item.messageTenNhomNCC;
            this.messageDienThoai = item.messageDienThoai;
            this.messageDiaChi = item.messageDiaChi;
            this.messageFax =item.messageFax;
            this.messageMST = item.messageMST;
            this.messageSoTK1 = item.messageSoTK1;
            this.messageNganHang1 = item.messageNganHang1;
            this.messageSoTK2 = item.messageSoTK2;
            this.messageNganHang2 = item.messageNganHang2;
            this.messageEmail = item.messageEmail;
            this.messageNguoiLienHe = item.messageNguoiLienHe;
            this.messageSoDT_NguoiLienHe = item.messageSoDT_NguoiLienHe;
            this.messageNguoiDaiDien = item.messageNguoiDaiDien;
            this.messageSoDT_NguoiDaiDien = item.messageSoDT_NguoiDaiDien;
            this.messageGhiChu = item.messageGhiChu;
            this.messageXepLoai = item.messageXepLoai;
            this.messageSoNgayThanhToan = item.messageSoNgayThanhToan;
            this.messageTenTinh=item.messageTenTinh;
            this.isError=item.isError;
        }
}
